import styled from 'styled-components';


export const Paragraph = styled.p`
    font-family: 'Poppins';
    font-size: 0.975rem;
    font-weight: ${({textBold}) => (textBold ? '700' : '500')};
    color: ${({textDark}) => (textDark ? '#2D2D2D' : '#fff')};

`